import { useState } from "react";
import StyleWrapper, {
    StyleContentWrapper,
    StyleVolksHeader,
    StyleLineLeft,
    LogoVw,
    StyleLineRight,
    StyleButtonContainer,
    StyleLogoBestDrivePremiado,
} from "./style";
import Button from "components/button";

export default ({setIsModalOpen, setIsModalOpenRevendedor, setIsModalOpenWinners}) => {
    return (
        <>
            <StyleWrapper>
                <StyleContentWrapper>
                    <StyleLogoBestDrivePremiado>
                        <img
                            src="/assets/img/2026-v2/best-drive-premiado-cbf.svg"
                            alt="Volks Vale"
                        />
                    </StyleLogoBestDrivePremiado>
                    <div>
                        <StyleButtonContainer>
                            <Button onClick={() => setIsModalOpenWinners(true)}>
                                Ganhadores
                            </Button>
                            <br />
                            <br />
                            <p>Período de participação: de 11/05/2025 a 11/08/2026. </p>
                            <Button onClick={() => setIsModalOpen(true)}>
                                Consultar meu número da sorte
                            </Button>
                            <br />
                            <br />
                            <Button onClick={() => setIsModalOpenRevendedor(true)}>
                                Revendedor
                            </Button>
                        </StyleButtonContainer>
                        <StyleVolksHeader>
                            <StyleLineLeft />
                            <LogoVw />
                            <StyleLineRight />
                        </StyleVolksHeader>
                        <p>
                            Período de participação: de 11/05/2025 a 11/08/2026.
                            Serão considerados válidos apenas os teste drives realizados nas concessionárias participantes e que atendam aos parâmetros descritos no regulamento, limitado a um prêmio por CPF. 
                            Certificado de autorização N.° 04.049765/2026.
                        </p>
                    </div>
                </StyleContentWrapper>
            </StyleWrapper>
        </>
    );
};
